import getEnv from '@settings/getEnv';
import { loggerFactory } from '@settings/services/logger';
import Cookies from 'cookies-ts';

import { DealPageService } from './DealPageService';
import { DealPageServiceInterface } from './interface';

// Фабрика сервиса
export const dealPageService: { (): DealPageServiceInterface } = () => {
  const { REACT_APP_BITRIX_ENDPOINT, REACT_APP_AUTH_COOKIE } = getEnv();
  const cookies = new Cookies();

  const jwt = cookies.get(REACT_APP_AUTH_COOKIE);
  return new DealPageService(loggerFactory(), REACT_APP_BITRIX_ENDPOINT, jwt ?? '');
};
